import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    staticClass: "hide-tabs"
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "descricao",
      "label-for": "descricao",
      "label": "Descrição"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.validateState('descricao'),
      "autofocus": ""
    },
    model: {
      value: _vm.$v.form.descricao.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.descricao, "$model", $$v);
      },
      expression: "$v.form.descricao.$model"
    }
  })], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "status",
      "label-for": "status",
      "label": "Status"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.status,
      expression: "form.status"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.status) ? _vm._i(_vm.form.status, null) > -1 : _vm.form.status
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.status,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "status", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "status", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "status", $$c);
        }
      }
    }
  }), _c('span')])])])], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "aplicar_sem_cliente",
      "label-for": "aplicar_sem_cliente",
      "label": "Aplicar sem Cliente"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.aplicar_sem_cliente,
      expression: "form.aplicar_sem_cliente"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.aplicar_sem_cliente) ? _vm._i(_vm.form.aplicar_sem_cliente, null) > -1 : _vm.form.aplicar_sem_cliente
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.aplicar_sem_cliente,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "aplicar_sem_cliente", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "aplicar_sem_cliente", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "aplicar_sem_cliente", $$c);
        }
      }
    }
  }), _c('span')])])])], 1)], 1)], 1)], 1), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Produto",
      "label-for": "name"
    }
  }, [_c('VueSelect', {
    ref: "buscarProduto",
    attrs: {
      "filterable": false,
      "options": _vm.produtosFetched
    },
    on: {
      "input": _vm.setProduto,
      "search": _vm.onSearchProduto
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(_vm._s(option.codigo) + " - " + _vm._s(option.descricao))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.produtoSelected,
      callback: function callback($$v) {
        _vm.produtoSelected = $$v;
      },
      expression: "produtoSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Busque o produto pela descrição ")])], 2)], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Preço lista R$",
      "label-for": "total"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "total",
      "name": "total"
    },
    model: {
      value: _vm.produtoSelected.preco_lista,
      callback: function callback($$v) {
        _vm.$set(_vm.produtoSelected, "preco_lista", $$v);
      },
      expression: "produtoSelected.preco_lista"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label-for": "add"
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.addProduto();
      }
    }
  }, [_vm.windowWidth > 768 ? _c('Plus', {
    staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2 mt-9"
  }) : _c('button', {
    staticClass: "btn btn-info btn-hover-dark font-weight-bolder font-size-lg ml-2",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(" Adicionar produto ")])], 1)])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-for": "add"
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.show('modal-busca-grupo');
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-hover-dark font-weight-bolder font-size-lg ml-2",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(" Buscar por grupo ")])])])], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label-for": "add"
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.show('modal-aplicar-para-estoque');
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-hover-dark font-weight-bolder font-size-lg ml-2",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(" Aplicar para todo estoque ")])])])], 1)], 1), _c('b-row', [_c('b-col', [_c('TableApp', {
    key: _vm.keyToRender,
    ref: "nome",
    attrs: {
      "item": "produto",
      "subTitulo": "",
      "data": _vm.produtos,
      "fields": _vm.fields,
      "classFilterColumn": "nome"
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'item' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "item"
          },
          slot: "item"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.originalIndex + 1) + " / " + _vm._s(props.rowData.codigo) + " ")])])]) : _vm._e(), props.field == 'descricao' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "nome"
          },
          slot: "nome"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.descricao) + " ")])])]) : _vm._e(), props.field == 'preco_lista' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "preco_lista"
          },
          slot: "preco_lista"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.preco_lista, "preco")) + " ")]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.handleDeleteProduto(props.rowData.originalIndex);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)])])])]) : _vm._e()];
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_nova_lista",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.salvarLista
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'lista'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])]), _c('b-modal', {
    attrs: {
      "id": "modal-busca-grupo",
      "title": "Buscar por grupo de produto",
      "size": "lg",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          ref: "save_grupo",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.salvarProdutosGrupo
          }
        }, [_vm._v(" Confirmar ")])];
      }
    }])
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Grupo de produtos",
      "label-for": "grupoValue"
    }
  }, [_c('VueSelect', {
    ref: "buscarGrupoProduto",
    attrs: {
      "filterable": false,
      "options": _vm.grupos
    },
    on: {
      "open": _vm.onSearchGrupo,
      "search": _vm.onSearchGrupo
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(_vm._s(option.nome))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(_vm._s(option.nome))])];
      }
    }]),
    model: {
      value: _vm.grupoSelected,
      callback: function callback($$v) {
        _vm.grupoSelected = $$v;
      },
      expression: "grupoSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o grupo pelo descrição ")])], 2)], 1)], 1)], 1), _c('b-row'), _c('div', {
    staticClass: "mx-auto"
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Percentual %",
      "label-for": "grupoValue"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "grupoValue",
      "name": "grupoValue"
    },
    model: {
      value: _vm.grupoOptions.value,
      callback: function callback($$v) {
        _vm.$set(_vm.grupoOptions, "value", $$v);
      },
      expression: "grupoOptions.value"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fator",
      "label-for": "fator"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.grupoOptions.fator,
      expression: "grupoOptions.fator"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true
    },
    attrs: {
      "name": "selectFator",
      "id": "selectFator"
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.grupoOptions, "fator", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "acrescimo"
    }
  }, [_vm._v("Acrescimo")]), _c('option', {
    attrs: {
      "value": "desconto"
    }
  }, [_vm._v("Desconto")])])])], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-for": "apply"
    }
  }, [_c('button', {
    ref: "applyPrecoGrupo",
    staticClass: "btn btn-info btn-hover-dark font-weight-bolder font-size-lg ml-2 mt-8",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.aplicarPrecoGrupo
    }
  }, [_vm._v(" Aplicar ")])])], 1)], 1), _c('b-row', [_c('b-col', [_c('TableApp', {
    ref: "grupoProdutos",
    attrs: {
      "item": "produto",
      "subTitulo": "",
      "data": _vm.produtosGrupo,
      "fields": _vm.grupoFields,
      "classFilterColumn": "grupoProdutos"
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'id' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "codigo"
          },
          slot: "codigo"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.codigo) + " ")])])]) : _vm._e(), props.field == 'descricao' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "descricao"
          },
          slot: "descricao"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.descricao) + " ")])])]) : _vm._e(), props.field == 'preco' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "preco"
          },
          slot: "preco"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.preco, "preco")) + " ")]) : _vm._e(), props.field == 'preco_lista' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "preco_lista"
          },
          slot: "preco_lista"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.preco_lista, "preco")) + " ")]) : _vm._e()];
      }
    }])
  })], 1)], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-aplicar-para-estoque",
      "title": "Aplicar lista para todo estoque?",
      "size": "md",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var ok = _ref2.ok,
          cancel = _ref2.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return _vm.confirmCancel('lista');
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          ref: "aplicarPrecoParaEstoque",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.aplicarPrecoParaEstoque
          }
        }, [_vm._v("Aplicar")])];
      }
    }])
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Percentual %",
      "label-for": "grupoValue"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "grupoValue",
      "name": "grupoValue"
    },
    model: {
      value: _vm.grupoOptions.value,
      callback: function callback($$v) {
        _vm.$set(_vm.grupoOptions, "value", $$v);
      },
      expression: "grupoOptions.value"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fator",
      "label-for": "fator"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.grupoOptions.fator,
      expression: "grupoOptions.fator"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true
    },
    attrs: {
      "name": "selectFator",
      "id": "selectFator"
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.grupoOptions, "fator", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "acrescimo"
    }
  }, [_vm._v("Acrescimo")]), _c('option', {
    attrs: {
      "value": "desconto"
    }
  }, [_vm._v("Desconto")])])])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };